"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressForm = AddressForm;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

var _axios = _interopRequireDefault(require("axios"));

var _cssClasses = _interopRequireDefault(require("../../helpers/cssClasses"));

var _utils = require("../../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function AddressForm() {
  /**
   * DOM selectors.
   */
  var selectors = {
    sailthruListWrapper: '[js-sailthru-list="wrapper"]',
    sailthruListCheckbox: '[js-sailthru-checkbox="subscribe_list"]'
  };
  /**
   * Node selectors.
   */

  var nodeSelectors = {
    newAddressForm: document.querySelector('[js-addresses="newForm"]'),
    addressNewToggle: document.querySelectorAll('[js-addresses="newFormToggle"]'),
    addressEditToggle: document.querySelectorAll('[js-addresses="editAddress"]'),
    addressDeleteToggle: document.querySelectorAll('[js-addresses="deleteAddress"]'),
    countryOptions: document.querySelectorAll('[js-addresses="countryOption"]')
  };
  /**
   * Initialize address form events.
   */

  function init() {
    setToggleEvents();

    if (theme.sailthru.accountEnabled) {
      initSailthru();
    }
  }

  function setToggleEvents() {
    _toConsumableArray(nodeSelectors.addressNewToggle).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleFormToggle(event);
      });
    });

    _toConsumableArray(nodeSelectors.addressEditToggle).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleEditToggle(event);
      });
    });

    _toConsumableArray(nodeSelectors.addressDeleteToggle).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleDelete(event);
      });
    });

    if (nodeSelectors.newAddressForm) {
      if (Shopify) {
        initializeObservers();
      }

      initialiseEditObservers();
    }
    /**
     * Initialize each edit form's country/province selector.
     */


    function initialiseEditObservers() {
      _toConsumableArray(nodeSelectors.countryOptions).forEach(function (element) {
        var formId = element.dataset.formId;
        var countrySelector = "AddressCountry_".concat(formId);
        var provinceSelector = "AddressProvince_".concat(formId);
        var containerSelector = "AddressProvinceContainer_".concat(formId);
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });
    }
    /**
     * Toggle address form.
     */


    function handleFormToggle(event) {
      event.preventDefault();
      nodeSelectors.newAddressForm.classList.toggle(_cssClasses["default"].hidden);
    }
    /**
     * Handle edit address toggle on each for element.
     * @param {Event} event - Click event.
     */


    function handleEditToggle(event) {
      var target = event.currentTarget;
      var formId = target.dataset.formId;
      document.querySelector("#EditAddress_".concat(formId)).classList.toggle(_cssClasses["default"].hidden);
    }
    /**
     * Handle delete on address.
     */


    function handleDelete(event) {
      var target = event.currentTarget;
      var formId = target.dataset.formId;
      var confirmMessage = target.dataset.confirmMessage;

      if (window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink("/account/addresses/".concat(formId), {
          parameters: {
            _method: 'delete'
          }
        });
      }
    }
    /**
     * Initialize observers on address selectors, defined in shopify_common.js.
     */


    function initializeObservers() {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }
  }
  /**
   * Initialize sailthru events.
   */


  function initSailthru() {
    addSailthruDataForm();
    loadSailthruData();
  }
  /**
   * Add sailthru data form.
   */


  function addSailthruDataForm() {
    var sailthruLists = theme.sailthru.lists.split(',');
    var formTemplate = '<form js-sailthru-form="lists">';
    sailthruLists.forEach(function (list) {
      var trimList = list.trim();
      formTemplate = "".concat(formTemplate, "\n                      <div class=\"form-group__field\">\n                        <input js-sailthru-checkbox=\"subscribe_list\" type=\"checkbox\" id=\"").concat(trimList, "\" name=\"").concat(trimList, "\">\n                        <label for=\"").concat(trimList, "\">").concat(trimList, "</label>\n                      </div>");
    });
    formTemplate = "".concat(formTemplate, "\n                    </form>");
    var listWrapper = document.querySelector(selectors.sailthruListWrapper);
    listWrapper.innerHTML = formTemplate;
    setSailthruClickEvents();
  }
  /**
   * Initialize sailthru events.
   */


  function setSailthruClickEvents() {
    var subscribeListCheckboxes = document.querySelectorAll(selectors.sailthruListCheckbox);

    _toConsumableArray(subscribeListCheckboxes).forEach(function (checkbox) {
      (0, _utils.on)('click', checkbox, function (event) {
        return toggleSubscribeList(event);
      });
    });
  }
  /**
   * Handle subscribe list toggle.
   */


  function toggleSubscribeList() {
    var lists = {};
    var subscribeListCheckboxes = document.querySelectorAll(selectors.sailthruListCheckbox);

    _toConsumableArray(subscribeListCheckboxes).forEach(function (checkbox) {
      if (checkbox.checked === true) {
        lists[checkbox.name] = 1;
        return;
      }

      lists[checkbox.name] = 0;
    });

    updateSailthruData(lists);
  }
  /**
   * Load sailthru data
   */


  function loadSailthruData() {
    _axios["default"].get("".concat(theme.sailthru.getUserApi, "?email=").concat(theme.customer.email)).then(function (response) {
      if (response.error === true) {
        return 'failed';
      }

      var subscribeListCheckboxes = document.querySelectorAll(selectors.sailthruListCheckbox);

      _toConsumableArray(subscribeListCheckboxes).forEach(function (checkbox) {
        if (response.data.response.lists.hasOwnProperty(checkbox.name)) {
          checkbox.checked = true;
        }
      });

      return 'success';
    })["catch"](function (err) {
      return err;
    });
  }
  /**
   * Update sailthru data
   */


  function updateSailthruData(lists) {
    var data = {
      email: theme.customer.email,
      lists: lists
    };

    _axios["default"].post("".concat(theme.sailthru.updateUserApi), data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(function (response) {
      return response;
    })["catch"](function (err) {
      loadSailthruData();
      return err;
    });
  }

  return Object.freeze({
    init: init
  });
}

AddressForm().init();